<script setup lang="ts">
import { computed, warn } from 'vue'
import * as importedIcons from './icons'
import * as importedFileIcons from './misc_icons'

const icons = importedIcons as Record<string, any>
const fileIcons = importedFileIcons as Record<string, any>

const props = withDefaults(
  defineProps<{
    name: keyof typeof icons | keyof typeof fileIcons
    class?: string | string[] | Record<string, boolean>
    size?: number | string
  }>(),
  {
    class: 'h-4 w-4 block',
  },
)

const IconComponent = computed(() => {
  if (props.name in icons) return icons[props.name]
  if (props.name in fileIcons) return fileIcons[props.name]
  warn(`Icon \"${String(props.name)}\" not found`)
  return undefined
})

const style = computed(() => (props.size ? { width: `${props.size}px`, height: `${props.size}px` } : {}))
</script>

<template>
  <component
    :is="IconComponent || 'span'"
    v-bind="$attrs"
    :class="class"
    :style="style"
    :aria-label="typeof props.name === 'string' ? props.name : undefined"
    role="img"
  />
</template>
